import { FDCNotifications } from '../../../cimsPage/instances/fdc'
import { Notifications } from '../../common'

const { View, Edit } = Notifications({
  page: FDCNotifications,
  view: 'B2CFD73E-A2A0-4ACB-86DC-4DB7B316A710',
  edit: 'E23BAC9B-3D1B-4254-93E6-F039E6D78079',
})

export const ViewFDCNotification = View
export const EditFDCNotification = Edit

export type FDCNotificationPermission =
  | typeof ViewFDCNotification
  | typeof EditFDCNotification
